import { Dispatch, SetStateAction, useState } from "react";
import { CancelButton } from "../../../../components/ui/CancelButton";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { CircularProgress } from "@mui/joy";
import { UpdateUserStatusRequest, UserStatus } from "../../../../types/user";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { useChangeVendedorStatusMutation } from "../../../../api/vendedorApi";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

interface Props {
    vendedorId: number;
    name: string;
    currentStatus: UserStatus;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
}

export function ChangeVendedorStatus({ vendedorId, name, currentStatus, setOpenModal }: Props) {
    const [changeVendedorStatus, { isLoading, isSuccess }] = useChangeVendedorStatusMutation();

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const messageTitle = currentStatus == "Activo"
        ? `Confirmar la desactivación del usuario ${name}` 
        : `Confirmar la reactivación del usuario ${name}`;

    const newStatus: UserStatus = currentStatus == "Activo" ? "Inactivo" : "Activo";

    const handleChangeVendedorStatus = async (status: UserStatus) => {
        try {
            setErrorMessage(null);
            const request: UpdateUserStatusRequest = {
                userId: vendedorId,
                newStatus: status
            };
            await changeVendedorStatus(request);
            setOpenModal(false);
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    if(isSuccess)
        return(
            <div>
                <div className="flex gap-x-2 justify-center">
                    <div className="flex items-center justify-center">
                        <CheckCircleRoundedIcon sx={{ height: 30, width: 30, color: "green"}}/>
                    </div>
                    <p className="font-semibold text-center text-xl">El status del usuario se ha actualizado con exito</p>
                </div>

                <div className="flex justify-center gap-x-4 mt-4 h-[30px]">
                    <CancelButton
                        text="Regresar"
                        onClick={()=> setOpenModal(false)}/>
                </div>
            </div>

        );

    return(
        <div className="bg-white w-[600px] rounded p-4">

            <p className="font-semibold text-center text-xl">{messageTitle}</p>

            {errorMessage && (
                <div className="my-2">
                    <ErrorMessage
                        customMessage>
                        <p className="text-sm">{errorMessage}</p>
                    </ErrorMessage>
                </div>
            )}

            <div className="flex justify-center gap-x-4 mt-4 h-[30px]">
                {isLoading
                ? 
                <div className="w-[105px] h-[30px] flex items-center justify-center">
                    <CircularProgress sx={{
                        "--CircularProgress-progressThickness": "4px",
                        "--CircularProgress-trackThickness": "4px",
                        "--CircularProgress-size": "25px"
                    }}/>
                </div>
                :
                <>
                <button
                    onClick={() => handleChangeVendedorStatus(newStatus)}
                    className={`border-2 ${currentStatus == "Activo" ? "border-red-300 hover:bg-red-100" : "border-green-600 bg-green-100 hover:bg-green-300"}  rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center`}>
                    <p className={`${currentStatus == "Activo" ? "text-red-400" : "text-green-800"} text-[13px] font-semibold text-center`}>{currentStatus == "Activo" ? "Desactivar" : "Reactivar"}</p>
                </button>

                <CancelButton
                    text="Regresar"
                    onClick={()=> setOpenModal(false)}
                    />
                </>}
            </div>
        </div>
    );
}
